(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-tag-assistant"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init() {
      const root = document.querySelector('[data-menu-assistant]');
      if (!root) return;
      if (root.dataset.menuAssistantInit === '1') return;
      root.dataset.menuAssistantInit = '1';

      const menuJsonEl = root.querySelector('[data-menu-json]');
      const table = root.querySelector('[data-table]');
      const statusEl = root.querySelector('[data-status]');
      const searchInput = root.querySelector('[data-search]');
      const refreshBtn = root.querySelector('[data-refresh]');
      const tagFilterSelect = root.querySelector('[data-filter-tags]');
      const typeFilterSelect = root.querySelector('[data-filter-type]');
      const typeFilterField = root.querySelector('[data-type-filter-field]');
      const pageSizeSelect = root.querySelector('[data-page-size]');
      const paginationEl = root.querySelector('[data-pagination]');
      const paginationPagesEl = root.querySelector('[data-pagination-pages]');
      const pagePrevBtn = root.querySelector('[data-page-prev]');
      const pageNextBtn = root.querySelector('[data-page-next]');
      let filterMode = 'all';
      let typeFilter = '';
      let currentPage = 1;
      let pageSize = Number(pageSizeSelect?.value || 12) || 12;
      const apiKeyInput = root.querySelector('[data-api-key]');
      const saveKeyBtn = root.querySelector('[data-save-key]');
      const apiModal = root.querySelector('[data-api-modal]');
      const apiModalInput = root.querySelector('[data-api-modal-input]');
      const apiModalSaveBtn = root.querySelector('[data-api-modal-save]');

      if (!menuJsonEl || !table) return;

      const apiBase = (root.dataset.apiBase || 'https://api.fs-solutions.fr/shopify/net-lunettes/menu-tags/v1').replace(
        /\/+$/,
        ''
      );
      const collectionHandle = (root.dataset.collectionHandle || '').trim();

      const storedKey = localStorage.getItem('netlMenuApiKey') || '';
      if (apiKeyInput && storedKey) apiKeyInput.value = storedKey;
      if (apiModalInput && storedKey) apiModalInput.value = storedKey;

      const menuItems = JSON.parse(menuJsonEl.textContent || '[]');

      const extractTag = (url) => {
        try {
          const u = new URL(url, window.location.origin);
          const params = u.searchParams;
          const direct =
            params.get('filter.v.tag') || params.get('filter.p.tag') || params.get('constraint') || params.get('tag');
          if (direct) return direct;
          for (const [key, value] of params.entries()) {
            if (key.toLowerCase().includes('tag') && value) return value;
          }
          return '';
        } catch (e) {
          return '';
        }
      };
      const ignoreLabels = new Set(['voir tout', 'view all', 'tous', 'toutes', 'tout', 'all']);
      const structuralPathSegments = new Set(['enfant', 'enfants']);
      const normalizeMenuLabel = (value) => {
        const clean = (value || '')
          .toString()
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!clean) return '';
        if (ignoreLabels.has(clean)) return '';
        if (clean === 'toutes les montures' || clean === 'toutes les lunettes') return 'toutes';
        return clean.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
      };
      const normalizeTagKey = (value) => {
        return (value || '')
          .toString()
          .trim()
          .toLowerCase()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/\s+/g, ' ')
          .trim();
      };

      const splitPathLabels = (path) => {
        return (path || '')
          .split('>')
          .map((s) => s.toString().trim())
          .filter(Boolean);
      };

      const pathSegments = (path) => {
        return (path || '')
          .split('>')
          .map((s) => normalizeMenuLabel(s))
          .filter(Boolean);
      };
      const normalizedPathSegments = (path) => {
        return pathSegments(path).filter((segment, index) => {
          return !(index > 0 && structuralPathSegments.has(segment));
        });
      };
      const buildTagFromPath = (path) => {
        const parts = normalizedPathSegments(path);
        if (!parts.length) return '';
        return parts.join('_');
      };
      const parentTagsFromPath = (path) => {
        const parts = normalizedPathSegments(path);
        if (!parts.length) return [];
        const parents = [];

        if (parts[0]) {
          parents.push(`${parts[0]}_toutes`);
        }

        if (parts.length >= 3) {
          for (let i = 2; i < parts.length; i++) {
            const parentTag = parts.slice(0, i).join('_');
            if (parentTag) parents.push(parentTag);
          }
        }

        return Array.from(new Set(parents));
      };

      const menuTagsRaw = menuItems
        .map((item) => {
          const tag = (buildTagFromPath(item.path || '') || extractTag(item.url || '').trim()).trim();
          if (!tag) return null;
          return {
            tag,
            path: item.path || '',
            labels: splitPathLabels(item.path || ''),
            parents: parentTagsFromPath(item.path || ''),
          };
        })
        .filter(Boolean);

      const seenMenuTagKeys = new Set();
      const menuTags = menuTagsRaw.filter((entry) => {
        const key = normalizeTagKey(entry.tag);
        if (!key) return false;
        if (seenMenuTagKeys.has(key)) return false;
        seenMenuTagKeys.add(key);
        return true;
      });

      const buildMenuTree = (entries) => {
        const roots = [];
        const rootsByKey = new Map();
        const makeTreeKey = (label) => normalizeMenuLabel(label) || normalizeTagKey(label) || String(label || '');

        const ensureRoot = (label) => {
          const key = makeTreeKey(label);
          if (!rootsByKey.has(key)) {
            rootsByKey.set(key, { label, direct: [], branches: [], branchesByKey: new Map() });
            roots.push(rootsByKey.get(key));
          }
          return rootsByKey.get(key);
        };

        const ensureBranch = (root, label) => {
          const key = makeTreeKey(label);
          if (!root.branchesByKey.has(key)) {
            root.branchesByKey.set(key, { label, items: [] });
            root.branches.push(root.branchesByKey.get(key));
          }
          return root.branchesByKey.get(key);
        };

        entries.forEach((entry) => {
          const labels = entry.labels && entry.labels.length ? entry.labels : splitPathLabels(entry.path || '');
          const rootLabel = labels[0] || entry.tag;
          const root = ensureRoot(rootLabel);
          const option = {
            entry,
            label: labels.length > 1 ? labels[labels.length - 1] : entry.tag,
          };

          if (labels.length >= 3) {
            const branch = ensureBranch(root, labels[1]);
            branch.items.push(option);
            return;
          }

          root.direct.push(option);
        });

        return roots.map((root) => ({
          label: root.label,
          direct: root.direct,
          branches: root.branches,
        }));
      };

      const menuTree = buildMenuTree(menuTags);

      const legacyTagSet = new Set();
      menuItems.forEach((item) => {
        const urlTag = (extractTag(item.url || '') || '').trim();
        if (urlTag) legacyTagSet.add(normalizeTagKey(urlTag));
        const parts = normalizedPathSegments(item.path || '');
        if (!parts.length) return;

        const last = parts[parts.length - 1] || '';
        const lastKey = normalizeTagKey(last);
        if (lastKey && !ignoreLabels.has(lastKey) && lastKey !== 'toutes') {
          legacyTagSet.add(lastKey);
        }

        for (let i = 2; i < parts.length; i++) {
          const prefix = parts.slice(0, i).join('_');
          if (prefix) legacyTagSet.add(normalizeTagKey(prefix));
        }
      });

      const menuTagSet = new Set(menuTags.map((entry) => normalizeTagKey(entry.tag)));
      menuTags.forEach((entry) => {
        (entry.parents || []).forEach((p) => {
          if (p) menuTagSet.add(normalizeTagKey(p));
        });
      });

      const getMenuTagsForProduct = (product) => {
        return (product.tags || []).filter((tag) => menuTagSet.has(normalizeTagKey(tag)));
      };

      const menuTagMatchesType = (tag, type) => {
        const normalizedType = normalizeMenuLabel(type);
        if (!normalizedType) return true;

        const segments = normalizeTagKey(tag)
          .replace(/[^a-z0-9]+/g, '_')
          .split('_')
          .filter(Boolean);

        if (!segments.length) return false;
        if (normalizedType === 'enfant') {
          return segments.includes('enfant') || segments.includes('enfants');
        }

        return segments.includes(normalizedType);
      };

      const syncTypeFilterAvailability = () => {
        const enabled = filterMode === 'with';
        if (typeFilterField) {
          typeFilterField.classList.toggle('menu-assistant__filter-field--disabled', !enabled);
        }
        if (typeFilterSelect) {
          typeFilterSelect.disabled = !enabled;
          if (!enabled) {
            typeFilter = '';
            typeFilterSelect.value = '';
          }
        }
      };

      let products = [];
      let cursor = '';
      let loading = false;
      const HIDDEN_PRODUCT_IDS = new Set(['15477532721496']);
      const isHiddenProduct = (product) => {
        const id = String(product?.id || '');
        return HIDDEN_PRODUCT_IDS.has(id);
      };

      const getApiKey = () => (apiKeyInput?.value || localStorage.getItem('netlMenuApiKey') || '').trim();

      const setStatus = (msg, state = 'info') => {
        if (!statusEl) return;
        statusEl.textContent = msg;
        statusEl.dataset.state = state;
      };

      const syncApiKeyInputs = (value) => {
        const safeValue = (value || '').trim();
        if (apiKeyInput) apiKeyInput.value = safeValue;
        if (apiModalInput) apiModalInput.value = safeValue;
      };

      const openApiModal = () => {
        if (!apiModal) return;
        apiModal.hidden = false;
        apiModalInput?.focus();
      };

      const closeApiModal = () => {
        if (!apiModal) return;
        apiModal.hidden = true;
      };

      const persistApiKey = (value) => {
        const key = (value || '').trim();
        localStorage.setItem('netlMenuApiKey', key);
        syncApiKeyInputs(key);
        return key;
      };

      const ensureApiKey = () => {
        const key = getApiKey();
        if (key) return key;
        openApiModal();
        setStatus('Renseignez la clé API pour continuer.', 'info');
        return '';
      };

      const handleApiKeySave = (value) => {
        const key = persistApiKey(value);
        if (!key) {
          openApiModal();
          setStatus('Clé API vide.', 'error');
          return '';
        }
        closeApiModal();
        setStatus('Clé API enregistrée.', 'info');
        if (!products.length && !loading) loadProducts(true);
        return key;
      };

      saveKeyBtn?.addEventListener('click', () => {
        handleApiKeySave(apiKeyInput?.value || '');
      });

      apiModalSaveBtn?.addEventListener('click', () => {
        handleApiKeySave(apiModalInput?.value || '');
      });

      apiModalInput?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleApiKeySave(apiModalInput.value || '');
        }
      });

      const renderRow = (product) => {
        const menuTagsForProduct = getMenuTagsForProduct(product);
        const productTagSet = new Set((product.tags || []).map((t) => normalizeTagKey(t)));
        const selectedEntries = menuTags.filter((entry) => productTagSet.has(normalizeTagKey(entry.tag)));
        const selectedTagKeys = new Set(selectedEntries.map((entry) => normalizeTagKey(entry.tag)));
        const summaryLabel =
          selectedEntries.length === 0
            ? 'Assigner des sous-catégories'
            : selectedEntries.length === 1
              ? selectedEntries[0].path
              : `${selectedEntries.length} sous-catégories`;
        const tagBadges = menuTagsForProduct.length
          ? menuTagsForProduct.map((t) => `<span class="menu-assistant__tag">${t}</span>`).join('')
          : '<span class="menu-assistant__hint">Aucun</span>';

        const imageData =
          product.image ||
          product.featuredImage ||
          (product.images && product.images.edges && product.images.edges[0] && product.images.edges[0].node) ||
          null;

        const imageUrl =
          (typeof imageData === 'string'
            ? imageData
            : imageData && (imageData.url || imageData.src || imageData.originalSrc)) ||
          product.image_url ||
          '';

        const imageAlt = (imageData && (imageData.alt || imageData.altText || imageData.alt_text)) || product.title;
        const thumb = imageUrl
          ? `<img class="menu-assistant__thumb" src="${imageUrl}" alt="${imageAlt}" loading="lazy">`
          : `<div class="menu-assistant__thumb menu-assistant__thumb--empty"></div>`;

        const renderOption = (entry, label) => {
          const checked = selectedTagKeys.has(normalizeTagKey(entry.tag)) ? 'checked' : '';
          const autoTags = Array.from(new Set([].concat(entry.parents || [], entry.tag).filter(Boolean)));
          const autoTagsLabel = autoTags.join(', ');
          return `
            <label class="menu-assistant__option">
              <span class="menu-assistant__option-line">
                <input type="checkbox" name="menu-tag-${product.id}" data-tag="${entry.tag}" data-auto-tags="${autoTags.join('|')}" ${checked}>
                <span class="menu-assistant__option-label">
                  <span class="menu-assistant__option-title">${label || entry.tag}</span>
                  <span class="menu-assistant__option-tag">${entry.tag}</span>
                  <span class="menu-assistant__path">${entry.path || ''}</span>
                </span>
              </span>
              <span class="menu-assistant__tagsline">Tags envoyes: ${autoTagsLabel}</span>
            </label>
          `;
        };

        const optionsTree = menuTree
          .map((root) => {
            const rootSelected =
              root.direct.some((item) => selectedTagKeys.has(normalizeTagKey(item.entry.tag))) ||
              root.branches.some((branch) =>
                branch.items.some((item) => selectedTagKeys.has(normalizeTagKey(item.entry.tag)))
              );
            const rootOpen = rootSelected ? 'open' : '';

            const directOptions = root.direct.length
              ? `<div class="menu-assistant__tree-options">${root.direct
                  .map((item) => renderOption(item.entry, item.label))
                  .join('')}</div>`
              : '';

            const branchOptions = root.branches
              .map((branch) => {
                const branchSelected = branch.items.some((item) => selectedTagKeys.has(normalizeTagKey(item.entry.tag)));
                const branchOpen = branchSelected ? 'open' : '';
                return `
                  <details class="menu-assistant__tree-branch" ${branchOpen}>
                    <summary class="menu-assistant__tree-summary menu-assistant__tree-summary--branch">${branch.label}</summary>
                    <div class="menu-assistant__tree-panel">
                      <div class="menu-assistant__tree-options">
                        ${branch.items.map((item) => renderOption(item.entry, item.label)).join('')}
                      </div>
                    </div>
                  </details>
                `;
              })
              .join('');

            return `
              <details class="menu-assistant__tree-root" ${rootOpen}>
                <summary class="menu-assistant__tree-summary">${root.label}</summary>
                <div class="menu-assistant__tree-panel">
                  ${directOptions}
                  ${branchOptions}
                </div>
              </details>
            `;
          })
          .join('');

        const options = [
          `<button class="button button--secondary menu-assistant__clear-btn" type="button" data-clear-tags>Tout retirer</button>`,
          optionsTree || '<p class="menu-assistant__hint">Aucune sous-categorie disponible.</p>',
        ].join('');

        return `
        <div class="menu-assistant__row" data-id="${product.id}">
          <div>
            <div class="menu-assistant__product-row">
              ${thumb}
              <div class="menu-assistant__product-text">
                <div class="menu-assistant__product">${product.title}</div>
                <small class="menu-assistant__hint">ID ${product.id}</small>
              </div>
            </div>
          </div>
          <div class="menu-assistant__tags">${tagBadges}</div>
          <details class="menu-assistant__dropdown">
            <summary>${summaryLabel}</summary>
            <div class="menu-assistant__options">${options}</div>
          </details>
        </div>
      `;
      };

      const renderTable = (list) => {
        const head = `
        <div class="menu-assistant__row menu-assistant__row--head">
          <span>Produit</span>
          <span>Tags menu</span>
          <span>Assignation</span>
        </div>
      `;
        const rows = list.length
          ? list.map(renderRow).join('')
          : '<div class="menu-assistant__empty">Aucun produit pour ces filtres.</div>';
        table.innerHTML = head + rows;
      };

      const filterProducts = () => {
        const q = (searchInput?.value || '').trim().toLowerCase();
        return products.filter((p) => {
          if (isHiddenProduct(p)) return false;
          const matchesQuery = !q || p.title.toLowerCase().includes(q) || String(p.id).includes(q);
          const menuTagsForProduct = getMenuTagsForProduct(p);
          const hasMenuTags = menuTagsForProduct.length > 0;
          if (filterMode === 'with' && !hasMenuTags) return false;
          if (filterMode === 'without' && hasMenuTags) return false;
          if (filterMode === 'with' && typeFilter) {
            const matchesType = menuTagsForProduct.some((tag) => menuTagMatchesType(tag, typeFilter));
            if (!matchesType) return false;
          }
          return matchesQuery;
        });
      };

      const getPaginationItems = (totalPages, current) => {
        if (totalPages <= 1) return [1];

        const items = [];
        for (let page = 1; page <= totalPages; page += 1) {
          const isEdge = page === 1 || page === totalPages;
          const isNearCurrent = Math.abs(page - current) <= 1;
          if (totalPages <= 7 || isEdge || isNearCurrent) {
            items.push(page);
            continue;
          }

          if (items[items.length - 1] !== 'ellipsis') {
            items.push('ellipsis');
          }
        }

        return items;
      };

      const updatePagination = (totalItems) => {
        const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
        currentPage = Math.min(Math.max(currentPage, 1), totalPages);

        if (paginationEl) {
          paginationEl.hidden = totalItems === 0 || totalPages === 1;
        }

        if (pagePrevBtn) {
          pagePrevBtn.disabled = currentPage <= 1;
        }

        if (pageNextBtn) {
          pageNextBtn.disabled = currentPage >= totalPages;
        }

        if (!paginationPagesEl) return totalPages;

        const paginationItems = getPaginationItems(totalPages, currentPage);
        paginationPagesEl.innerHTML = paginationItems
          .map((item) => {
            if (item === 'ellipsis') {
              return '<span class="menu-assistant__pagination-ellipsis">...</span>';
            }

            const activeClass = item === currentPage ? ' is-active' : '';
            return `
              <button
                class="button button--secondary menu-assistant__pagination-page${activeClass}"
                type="button"
                data-page="${item}"
              >
                ${item}
              </button>
            `;
          })
          .join('');

        return totalPages;
      };

      const renderProductsView = () => {
        const filteredProducts = filterProducts();
        const totalItems = filteredProducts.length;
        const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
        currentPage = Math.min(Math.max(currentPage, 1), totalPages);

        const startIndex = totalItems ? (currentPage - 1) * pageSize : 0;
        const visibleProducts = filteredProducts.slice(startIndex, startIndex + pageSize);

        renderTable(visibleProducts);
        updatePagination(totalItems);

        const loadedCount = products.filter((product) => !isHiddenProduct(product)).length;
        if (!loading) {
          const pageLabel = totalItems
            ? `Page ${currentPage}/${totalPages} - ${startIndex + 1}-${Math.min(startIndex + visibleProducts.length, totalItems)} sur ${totalItems}`
            : 'Aucun resultat';
          setStatus(`Produits charges : ${loadedCount} | ${pageLabel}`, 'info');
        }
      };

      const loadProducts = async (reset = false) => {
        const apiKey = ensureApiKey();
        if (!apiKey) return;
        if (loading) return;
        loading = true;
        if (refreshBtn) refreshBtn.disabled = true;
        setStatus('Chargement des produits...', 'loading');

        if (reset) {
          products = [];
          cursor = '';
          currentPage = 1;
        }

        try {
          let pageCursor = cursor;

          do {
            const params = new URLSearchParams();
            if (pageCursor) params.set('cursor', pageCursor);
            if (collectionHandle) params.set('collection_handle', collectionHandle);
            const qs = params.toString();
            const url = qs ? `${apiBase}/products?${qs}` : `${apiBase}/products`;
            const res = await fetch(url, {
              headers: {
                'Content-Type': 'application/json',
                'x-netl-admin-key': apiKey,
              },
            });
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (data?.status !== 'ok') throw new Error(data?.message || 'Erreur');
            const incomingItems = (data.items || []).filter((p) => !isHiddenProduct(p));
            products = products.concat(incomingItems);
            pageCursor = data.next_cursor || '';
            cursor = pageCursor;
            setStatus(`Chargement des produits... ${products.filter((product) => !isHiddenProduct(product)).length} charges`, 'loading');
          } while (pageCursor);

          renderProductsView();
        } catch (e) {
          setStatus(`Erreur chargement produits : ${e.message || e}`, 'error');
        } finally {
          loading = false;
          if (refreshBtn) refreshBtn.disabled = false;
        }
      };

      const saveTags = async (productId, tags, rowEl) => {
        const apiKey = ensureApiKey();
        if (!apiKey) return;
        rowEl?.classList.add('menu-assistant__row--saving');
        try {
          const res = await fetch(`${apiBase}/products/${productId}/tags`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-netl-admin-key': apiKey,
            },
            body: JSON.stringify({ tags }),
          });
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          const data = await res.json();
          if (data?.status !== 'ok') throw new Error(data?.message || 'Erreur');
          setStatus('Tags mis a jour.', 'info');
        } catch (e) {
          setStatus(`Erreur update tags : ${e.message || e}`, 'error');
        } finally {
          rowEl?.classList.remove('menu-assistant__row--saving');
        }
      };

      const buildTagsFromRowSelection = (row, product) => {
        const checkedInputs = Array.from(row.querySelectorAll('input[type="checkbox"][data-tag]:checked'));
        const autoTags = checkedInputs.flatMap((input) => {
          return (input.dataset.autoTags || '')
            .split('|')
            .map((t) => t.trim())
            .filter(Boolean);
        });
        const cleanTags = (product.tags || []).filter((t) => {
          const key = normalizeTagKey(t);
          return !menuTagSet.has(key) && !legacyTagSet.has(key);
        });
        return Array.from(new Set(cleanTags.concat(autoTags)));
      };

      const reopenAssignmentDropdown = (productId) => {
        const safeId = String(productId || '').replace(/"/g, '\\"');
        if (!safeId) return;
        const nextRow = table.querySelector(`[data-id="${safeId}"]`);
        const dropdown = nextRow?.querySelector('.menu-assistant__dropdown');
        if (dropdown) dropdown.open = true;
      };

      table.addEventListener('change', (e) => {
        const input = e.target.closest('input[type="checkbox"][data-tag]');
        if (!input) return;
        const row = e.target.closest('[data-id]');
        const productId = row?.dataset.id;
        const product = products.find((p) => String(p.id) === String(productId));
        if (!product || !row) return;
        const wasOpen = !!row.querySelector('.menu-assistant__dropdown')?.open;

        const nextTags = buildTagsFromRowSelection(row, product);
        product.tags = nextTags;
        renderProductsView();
        if (wasOpen) {
          requestAnimationFrame(() => reopenAssignmentDropdown(productId));
        }
        saveTags(productId, nextTags, row);
      });

      table.addEventListener('click', (e) => {
        const clearBtn = e.target.closest('[data-clear-tags]');
        if (!clearBtn) return;
        e.preventDefault();
        const row = e.target.closest('[data-id]');
        const productId = row?.dataset.id;
        const product = products.find((p) => String(p.id) === String(productId));
        if (!product || !row) return;
        const wasOpen = !!row.querySelector('.menu-assistant__dropdown')?.open;

        const cleanTags = (product.tags || []).filter((t) => {
          const key = normalizeTagKey(t);
          return !menuTagSet.has(key) && !legacyTagSet.has(key);
        });
        product.tags = cleanTags;
        renderProductsView();
        if (wasOpen) {
          requestAnimationFrame(() => reopenAssignmentDropdown(productId));
        }
        saveTags(productId, cleanTags, row);
      });

      tagFilterSelect?.addEventListener('change', () => {
        filterMode = tagFilterSelect.value || 'all';
        currentPage = 1;
        syncTypeFilterAvailability();
        renderProductsView();
      });

      typeFilterSelect?.addEventListener('change', () => {
        typeFilter = normalizeMenuLabel(typeFilterSelect.value || '');
        currentPage = 1;
        renderProductsView();
      });

      pageSizeSelect?.addEventListener('change', () => {
        pageSize = Number(pageSizeSelect.value || 12) || 12;
        currentPage = 1;
        renderProductsView();
      });

      pagePrevBtn?.addEventListener('click', () => {
        if (currentPage <= 1) return;
        currentPage -= 1;
        renderProductsView();
      });

      pageNextBtn?.addEventListener('click', () => {
        currentPage += 1;
        renderProductsView();
      });

      paginationPagesEl?.addEventListener('click', (event) => {
        const pageBtn = event.target.closest('[data-page]');
        if (!pageBtn) return;
        currentPage = Number(pageBtn.dataset.page || 1) || 1;
        renderProductsView();
      });

      syncTypeFilterAvailability();

      searchInput?.addEventListener('input', () => {
        currentPage = 1;
        renderProductsView();
      });
      refreshBtn?.addEventListener('click', () => loadProducts(true));

      loadProducts(true);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resale-account-requests"]) return;
  try {
    
  const reqList = document.querySelector('[data-requests]');
  const statusLabel = document.querySelector('[data-status]');
  const filterBar = document.querySelector('[data-filter-bar]');
  let allItems = [];
  let currentFilter = 'all';

  const badgeClass = (s) => `badge badge--${s || 'en_attente'}`;
  const labelStatus = (s) => {
    switch (s) {
      case 'etiquette_envoyee':
        return 'En transit';
      case 'a_valoriser':
        return 'A estimer';
      default:
        return 'Validée';
    }
  };
const labelCondition = (c) => {
    switch (c) {
      case 'comme_neuf':
        return 'Comme neuf';
      case 'tres_bon':
        return 'Très bon';
      case 'bon':
        return 'Bon';
      default:
        return c || '';
    }
  };

  function render(items) {
    if (!reqList) return;
    reqList.innerHTML = '';
    const filtered = items.filter((i) => currentFilter === 'all' || (i.status || 'en_attente') === currentFilter);
    if (!filtered.length) {
      reqList.innerHTML = '<p>Aucune demande.</p>';
      return;
    }
    filtered.forEach((item) => {
      const div = document.createElement('div');
      div.className = 'resale-requests__card';
      const files = (item.files || [])
        .map((f) => `<li><a href="${f.url}" target="_blank" rel="noopener">${f.name}</a></li>`)
        .join('');
      const labelLink = item.label_url
        ? `<div class="resale-requests__label"><a class="button button--secondary" href="${item.label_url}" target="_blank" rel="noopener">Telecharger le bordereau</a></div>`
        : '';
      const tracking = item.tracking ? `<div class="resale-requests__tracking">Suivi : ${item.tracking}</div>` : '';
      div.innerHTML = `
        <div class="resale-requests__row">
          <div class="resale-requests__row-main">
            <strong>${item.brand_model || ''}</strong>
            <div class="resale-requests__meta">
              <span><strong>Condition :</strong> ${labelCondition(item.condition)}</span>
              <span><strong>Correction :</strong> ${item.correction || '—'}</span>
              <span><strong>Catégorie :</strong> ${item.category || '—'}</span>
            </div>
          </div>
          <span class="${badgeClass(item.status)}">${labelStatus(item.status)}</span>
        </div>
        ${tracking}
        <div class="resale-requests__files"><small>Fichiers :</small><ul>${files || '<li>Aucun</li>'}</ul></div>
        ${labelLink}
      `;
      reqList.appendChild(div);
    });
  }

  async function loadRequests() {
    if (!reqList) return;
    try {
      if (statusLabel) statusLabel.textContent = 'Chargement...';
      const email = document.querySelector('[data-customer-email]')?.value;
      if (!email) return;
      const res = await fetch(`https://api.fs-solutions.fr/shopify/net-lunettes/resale/v1/requests?customer_email=${encodeURIComponent(email)}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      if (data?.status !== 'ok') throw new Error(data?.message || 'Erreur');
      allItems = data.items || [];
      render(allItems);
      if (statusLabel) statusLabel.textContent = `Demandes : ${allItems.length}`;
    } catch (e) {
      if (statusLabel) statusLabel.textContent = `Erreur : ${e.message || e}`;
    }
  }

  filterBar?.addEventListener('click', (e) => {
    const btn = e.target.closest('.chip');
    if (!btn) return;
    filterBar.querySelectorAll('.chip').forEach((c) => c.classList.remove('chip--active'));
    btn.classList.add('chip--active');
    currentFilter = btn.dataset.filter || 'all';
    render(allItems);
  });

  loadRequests();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resale-admin-demo"]) return;
  try {
    
(() => {
  function init() {
    const root = document.querySelector('section.resale-admin');
    if (!root) return;

    const table = root.querySelector('[data-table]');
    const filterBar = root.querySelector('[data-filter-bar]');
    const statusHint = root.querySelector('[data-status]');
    const detailBox = root.querySelector('[data-detail]');

    // Not the admin view (no table/filters).
    if (!table || !filterBar) return;

    if (root.dataset.netlResaleAdminInit === '1') return;
    root.dataset.netlResaleAdminInit = '1';

    // Defensive: remove any overlay that might block clicks.
    document.querySelectorAll('.sp-validate-overlay').forEach((el) => el.remove());

    const headRow = table.querySelector('.resale-admin__row--head');
    const headMarkup = headRow ? headRow.outerHTML : '';

    let allItems = [];
    let currentFilter = 'all';

    const labelStatus = (s) => {
      switch (s) {
        case 'etiquette_envoyee':
          return 'En transit';
        case 'a_valoriser':
          return 'A estimer';
        default:
          return 'Validée';
      }
    };

    const labelCondition = (c) => {
      switch (c) {
        case 'comme_neuf':
          return 'Comme neuf';
        case 'tres_bon':
          return 'Très bon';
        case 'bon':
          return 'Bon';
        default:
          return c || '';
      }
    };

    const badgeClass = (s) => `badge badge--${s || 'en_attente'}`;

    function renderRows(items) {
      const rows = (items || [])
        .map(
          (item) => `
        <div class="resale-admin__row" data-id="${item.id}">
          <span class="resale-admin__client">${item.customer_name || item.customer_email || 'Client'}</span>
          <span class="resale-admin__product">${item.brand_model || ''}</span>
          <span class="resale-admin__state">${labelCondition(item.condition)}</span>
          <span><span class="${badgeClass(item.status)}">${labelStatus(item.status)}</span></span>
          <span class="resale-admin__actions">
            <button type="button" class="button button--tertiary" data-action="view" data-id="${item.id}">Voir</button>
            <button type="button" class="button button--danger" data-action="delete" data-id="${item.id}">Supprimer</button>
          </span>
        </div>
      `,
        )
        .join('');
      table.innerHTML = headMarkup + rows;
    }

    function applyFilter() {
      const filtered = allItems.filter(
        (i) => currentFilter === 'all' || (i.status || 'en_attente') === currentFilter,
      );
      renderRows(filtered);
    }

    table.addEventListener('click', async (e) => {
      const viewBtn = e.target.closest('[data-action="view"]');
      const delBtn = e.target.closest('[data-action="delete"]');
      if (!viewBtn && !delBtn) return;
      const id = (viewBtn || delBtn)?.dataset.id;
      const item = allItems.find((x) => x.id === id);
      if (!item) return;

      if (delBtn) {
        if (!confirm(`Supprimer la demande ${id} ?`)) return;
        try {
          const res = await fetch(
            `https://api.fs-solutions.fr/shopify/net-lunettes/resale/v1/requests/${id}`,
            { method: 'DELETE' },
          );
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          allItems = allItems.filter((x) => x.id !== id);
          applyFilter();
          if (detailBox) detailBox.setAttribute('hidden', 'true');
          if (statusHint) statusHint.textContent = `Demandes recues : ${allItems.length}`;
        } catch (err) {
          console.warn('[netl-resale-admin] delete failed', err);
          alert('Suppression impossible');
        }
        return;
      }

      const filesHtml = (item.files || [])
        .map((f) => `<li><a href="${f.url}" target="_blank" rel="noopener">${f.name}</a></li>`)
        .join('');

      if (detailBox) {
        detailBox.innerHTML = `
        <h4>Demande ${item.id}</h4>
        <p><strong>Client :</strong> ${item.customer_name || 'Non renseigne'} (${item.customer_email || 'N/A'})</p>
        <p><strong>Produit :</strong> ${item.brand_model || ''}</p>
        <p><strong>Condition :</strong> ${labelCondition(item.condition)}</p>
        <p><strong>Correction :</strong> ${item.correction || ''}</p>
        <p><strong>Statut :</strong> ${labelStatus(item.status)}</p>
        <p><strong>Fichiers :</strong></p>
        <ul>${filesHtml || '<li>Aucun fichier</li>'}</ul>
        ${
          item.customer_id
            ? `<p><a class="button button--secondary resale-admin__settings-btn" href="/admin/customers/${item.customer_id}" target="_blank" rel="noopener">Ouvrir le client</a></p>`
            : ''
        }
      `;
        detailBox.removeAttribute('hidden');
      }
    });

    filterBar.addEventListener('click', (e) => {
      const btn = e.target.closest('.chip');
      if (!btn) return;
      filterBar.querySelectorAll('.chip').forEach((c) => c.classList.remove('chip--active'));
      btn.classList.add('chip--active');
      currentFilter = btn.dataset.filter || 'all';
      applyFilter();
    });

    async function loadRequests() {
      try {
        if (statusHint) statusHint.textContent = 'Chargement des demandes...';
        const res = await fetch(
          'https://api.fs-solutions.fr/shopify/net-lunettes/resale/v1/requests',
          {  },
        );
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (data?.status !== 'ok') throw new Error(data?.message || 'Erreur');
        allItems = data.items || [];
        applyFilter();
        if (statusHint) statusHint.textContent = `Demandes recues : ${allItems.length}`;
      } catch (e) {
        console.warn('[netl-resale-admin] load failed', e);
        if (statusHint) statusHint.textContent = `Erreur chargement : ${e.message || e}`;
      }
    }

    loadRequests();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: section reloaded
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resale-demo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init() {
      const root = document.querySelector('[data-resale-demo]');
      if (!root) return;

      // Avoid double-init
      if (root.dataset.netlResaleInit === '1') return;
      root.dataset.netlResaleInit = '1';

      const resaleForm = root.querySelector('[data-resale-form]');
      const chipGroups = root.querySelectorAll('[data-chip-group]');

      chipGroups.forEach((group) => {
        group.addEventListener('click', (event) => {
          const btn = event.target.closest('.chip');
          if (!btn) return;
          group.querySelectorAll('.chip').forEach((c) => c.classList.remove('chip--active'));
          btn.classList.add('chip--active');
        });
      });

      const myRequestsWrapper = root.querySelector('[data-my-requests-wrapper]');
      const myRequestsList = root.querySelector('[data-my-requests]');
      const myRequestsCount = root.querySelector('[data-my-requests-count]');

      const labelStatus = (s) => {
        switch (s) {
          case 'etiquette_envoyee':
            return 'En transit';
          case 'a_valoriser':
            return '\u00c0 estimer';
          default:
            return 'Valid\u00e9e';
        }
      };

      const statusClass = (s) => {
        switch (s) {
          case 'etiquette_envoyee':
            return 'is-transit';
          case 'a_valoriser':
            return 'is-estimate';
          default:
            return 'is-validated';
        }
      };

      const formatRequestDate = (isoValue) => {
        if (!isoValue) return '';
        const date = new Date(isoValue);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleDateString('fr-FR', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
      };

      if (!resaleForm) return;

      const steps = Array.from(resaleForm.querySelectorAll('[data-step]'));
      const stepIndicator = root.querySelector('[data-step-indicator]');
      const progressBar = root.querySelector('[data-step-progress]');

      const statusEl = resaleForm.querySelector('[data-resale-status]');
      const submitBtn = resaleForm.querySelector('[data-submit]');
      const labelLink = resaleForm.querySelector('[data-label-link]');

      const brandInput = resaleForm.querySelector('[data-input="brand-model"]');

      const fileInput = resaleForm.querySelector('[data-file-input]');
      const uploadTrigger = resaleForm.querySelector('[data-upload-trigger]');
      const uploadDrop = resaleForm.querySelector('[data-upload-drop]');
      const uploadList = resaleForm.querySelector('[data-upload-list]');

      const customerEmail = resaleForm.querySelector('[data-customer-email]')?.value || '';
      const rawHasAddress = (resaleForm.querySelector('[data-customer-has-address]')?.value || '')
        .toString()
        .trim()
        .toLowerCase();
      const addressesCountRaw = (resaleForm.querySelector('[data-customer-addresses-count]')?.value || '')
        .toString()
        .trim();
      const addressesCount = Number(addressesCountRaw);
      const defaultAddressFlag = (resaleForm.querySelector('[data-customer-default-address]')?.value || '')
        .toString()
        .trim();
      const hasAddress =
        rawHasAddress === 'true' || defaultAddressFlag === '1' || (!Number.isNaN(addressesCount) && addressesCount > 0);
      const trackingInput = resaleForm.querySelector('[data-input="tracking"]');

      const addressWarning = resaleForm.querySelector('[data-address-warning]');
      const addressWarningTop = resaleForm.querySelector('[data-address-warning-top]');
      const shippingStep = resaleForm.querySelector('[data-shipping-step]');

      if (!root.dataset.netlResaleAddressLog) {
        root.dataset.netlResaleAddressLog = '1';
        console.info(
          '[netl-resale] address flags',
          `raw=${rawHasAddress}`,
          `default=${defaultAddressFlag}`,
          `count=${addressesCountRaw}`,
          `hasAddress=${hasAddress}`,
          `email=${customerEmail}`
        );
      }

      const setStatus = (msg, state = 'info') => {
        if (!statusEl) return;
        statusEl.textContent = msg;
        statusEl.dataset.state = state;
      };

      const validateTracking = () => {
        const t = (trackingInput?.value || '').trim().toUpperCase();
        if (trackingInput && trackingInput.value !== t) trackingInput.value = t;
        return /^[0-9A-Z]{8,20}$/.test(t);
      };

      const updateSubmitState = () => {
        if (!submitBtn) return;
        const checklistDone = resaleForm.dataset.mrChecklistDone === '1';
        submitBtn.disabled = !hasAddress || !validateTracking() || !checklistDone;
      };

      const refreshFileList = () => {
        if (!uploadList) return;
        uploadList.innerHTML = '';
        if (!fileInput?.files?.length) return;
        Array.from(fileInput.files).forEach((file) => {
          const li = document.createElement('li');
          li.className = 'resale-demo__upload-pill';
          li.textContent = file.name;
          uploadList.appendChild(li);
        });
      };

      // File upload UX
      uploadTrigger?.addEventListener('click', () => fileInput?.click());
      uploadDrop?.addEventListener('click', (e) => {
        const target = e.target;
        if (target instanceof HTMLElement && target.closest('button')) return;
        fileInput?.click();
      });

      uploadDrop?.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadDrop.classList.add('is-dragover');
      });
      uploadDrop?.addEventListener('dragleave', () => uploadDrop.classList.remove('is-dragover'));
      uploadDrop?.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadDrop.classList.remove('is-dragover');
        if (!fileInput) return;
        if (!e.dataTransfer?.files?.length) return;
        fileInput.files = e.dataTransfer.files;
        refreshFileList();
      });

      fileInput?.addEventListener('change', refreshFileList);
      trackingInput?.addEventListener('input', updateSubmitState);

      // Copy helpers + checklist
      const copyButtons = Array.from(resaleForm.querySelectorAll('.resale-demo__copy'));
      const manualDoneButtons = Array.from(resaleForm.querySelectorAll('[data-manual-done]'));
      const mrStepCards = Array.from(resaleForm.querySelectorAll('.resale-demo__mr-step-card'));
      const mrGlobalProgress = resaleForm.querySelector('[data-mr-global-progress]');
      resaleForm.dataset.mrChecklistDone = '0';

      const recipientFieldTypes = [
        'dst-last-name',
        'dst-first-name',
        'dst-email',
        'dst-phone',
        'dst-address1',
        'dst-zip',
        'dst-city',
      ];
      const recipientCopyButtons = copyButtons.filter((btn) => recipientFieldTypes.includes(btn.dataset.copy));
      const recipientManualDoneButton = manualDoneButtons.find((btn) => btn.dataset.manualDone === 'recipient');

      const readCopyValue = (type) => (resaleForm.querySelector(`[data-copy-${type}]`)?.textContent || '').trim();

      const getTrackedButtons = () => Array.from(resaleForm.querySelectorAll('[data-mr-track]'));

      const getChecklistCounts = () => {
        const tracked = getTrackedButtons();
        const done = tracked.filter((btn) => btn.dataset.copyDone === '1').length;
        return { done, total: tracked.length };
      };

      const updateRecipientManualDoneVisibility = () => {
        if (!recipientManualDoneButton) return;
        const allRecipientCopiesDone =
          recipientCopyButtons.length > 0 &&
          recipientCopyButtons.every((btn) => btn.dataset.copyDone === '1');
        recipientManualDoneButton.hidden = allRecipientCopiesDone;
      };

      const updateMrProgress = () => {
        mrStepCards.forEach((card) => {
          const badge = card.querySelector('[data-mr-step-progress]');
          if (!badge) return;
          const trackedInCard = Array.from(card.querySelectorAll('[data-mr-track]'));
          const total = trackedInCard.length;
          const done = trackedInCard.filter((btn) => btn.dataset.copyDone === '1').length;
          badge.textContent = `${done}/${total}`;
          card.classList.toggle('is-done', total > 0 && done === total);
        });

        updateRecipientManualDoneVisibility();

        if (!mrGlobalProgress) return;
        const { done, total } = getChecklistCounts();
        const checklistDone = total > 0 && done === total;
        mrGlobalProgress.textContent = `${done}/${total} étapes validées`;
        mrGlobalProgress.classList.toggle('is-complete', checklistDone);
        resaleForm.dataset.mrChecklistDone = checklistDone ? '1' : '0';
        updateSubmitState();
      };

      const markButtonDone = (btn) => {
        if (!btn || btn.dataset.copyDone === '1') return;
        btn.dataset.copyDone = '1';
        btn.classList.add('is-done');
        btn.textContent = 'Fait';
        const row = btn.closest('.resale-demo__mr-field-row');
        row?.classList.add('is-done');
      };

      const markByType = (type) => {
        copyButtons.forEach((btn) => {
          if (btn.dataset.copy === type) markButtonDone(btn);
        });
      };

      const markActionDone = (type) => {
        if (type === 'recipient') {
          recipientFieldTypes.forEach((fieldType) => markByType(fieldType));
          markByType('recipient');
          return;
        }
        markByType(type);
      };

      const buildRecipientPayload = () => {
        const fields = [
          ['Nom', readCopyValue('dst-last-name')],
          ['Prénom', readCopyValue('dst-first-name')],
          ['Email', readCopyValue('dst-email')],
          ['Mobile', readCopyValue('dst-phone')],
          ['Adresse', readCopyValue('dst-address1')],
          ['Code postal', readCopyValue('dst-zip')],
          ['Ville', readCopyValue('dst-city')],
        ].filter(([, value]) => value);
        return fields.map(([label, value]) => `${label}: ${value}`).join('\n');
      };

      copyButtons.forEach((btn) => {
        btn.addEventListener('click', async () => {
          const type = btn.dataset.copy;
          const text = type === 'recipient' ? buildRecipientPayload() : readCopyValue(type);
          if (!text) return;
          try {
            await navigator.clipboard.writeText(text);
            markActionDone(type);
            updateMrProgress();
            const { done, total } = getChecklistCounts();
            setStatus(`Copie effectuée (${done}/${total}).`, 'info');
          } catch (e) {
            setStatus('Copie impossible.', 'error');
          }
        });
      });

      manualDoneButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const action = (btn.dataset.manualDone || '').trim();
          if (action) {
            markActionDone(action);
          }
          markButtonDone(btn);
          updateMrProgress();
          const { done, total } = getChecklistCounts();
          setStatus(`Étape marquée comme faite (${done}/${total}).`, 'info');
        });
      });

      updateMrProgress();

      // Stepper
      let currentStep = 1;
      const navButtons = resaleForm.querySelectorAll('[data-next-step], [data-submit]');

      const toggleAddressLock = () => {
        const locked = !hasAddress;
        navButtons.forEach((btn) => {
          btn.disabled = locked;
        });
        if (locked) {
          setStatus('Ajoutez votre adresse dans votre compte pour continuer.', 'error');
          addressWarningTop?.removeAttribute('hidden');
          if (addressWarningTop) addressWarningTop.style.display = 'grid';
        } else {
          addressWarningTop?.setAttribute('hidden', 'true');
          if (addressWarningTop) addressWarningTop.style.display = 'none';
        }
      };

      const showStep = (next) => {
        currentStep = Math.max(1, Math.min(3, Number(next) || 1));
        steps.forEach((el) => {
          const step = Number(el.dataset.step || 0);
          const isActive = step === currentStep;
          el.classList.toggle('is-active', isActive);
          if (isActive) {
            el.removeAttribute('hidden');
            el.style.removeProperty('display');
          } else {
            el.setAttribute('hidden', 'true');
            el.style.display = 'none';
          }
        });

        if (stepIndicator) stepIndicator.textContent = `Étape ${currentStep}/3`;
        if (progressBar) progressBar.style.width = `${(currentStep / 3) * 100}%`;

        toggleAddressLock();

        // Address gating
        if (currentStep === 3) {
          if (!hasAddress) {
            addressWarning?.removeAttribute('hidden');
            if (addressWarning) addressWarning.style.display = 'grid';
            shippingStep?.setAttribute('hidden', 'true');
            if (shippingStep) shippingStep.style.display = 'none';
            setStatus('Ajoutez votre adresse pour continuer.', 'error');
          } else {
            addressWarning?.setAttribute('hidden', 'true');
            if (addressWarning) addressWarning.style.display = 'none';
            shippingStep?.removeAttribute('hidden');
            if (shippingStep) shippingStep.style.removeProperty('display');
          }
        }

        updateSubmitState();

        // Focus first input
        const focusEl = steps.find((el) => Number(el.dataset.step) === currentStep)?.querySelector('input, button');
        focusEl?.focus?.();
      };

      resaleForm.addEventListener('click', (event) => {
        const nextBtn = event.target.closest('[data-next-step]');
        const prevBtn = event.target.closest('[data-prev-step]');

        if (prevBtn) {
          event.preventDefault();
          setStatus('', 'info');
          showStep(currentStep - 1);
          return;
        }

        if (!nextBtn) return;
        event.preventDefault();

        if (!hasAddress) {
          toggleAddressLock();
          return;
        }

        if (currentStep === 1) {
          const brand = (brandInput?.value || '').trim();
          if (!brand) {
            setStatus('Renseignez la marque / modèle.', 'error');
            brandInput?.focus();
            return;
          }
        }

        if (currentStep === 2) {
          if (!fileInput?.files?.length) {
            setStatus('Ajoutez au moins une photo pour continuer.', 'error');
            fileInput?.focus?.();
            return;
          }
        }

        setStatus('', 'info');
        showStep(currentStep + 1);
      });

      // My requests (right column)
      const renderMyRequests = (items = []) => {
        if (!myRequestsList) return;
        myRequestsList.innerHTML = '';
        if (myRequestsCount) myRequestsCount.setAttribute('hidden', 'true');

        if (!items.length) {
          myRequestsWrapper?.setAttribute('hidden', 'true');
          return;
        }

        myRequestsWrapper?.removeAttribute('hidden');
        if (myRequestsCount) {
          myRequestsCount.textContent = `${items.length}`;
          myRequestsCount.removeAttribute('hidden');
        }

        const maxItems = 3;
        const displayItems = items.slice(0, maxItems);

        displayItems.forEach((item) => {
          const li = document.createElement('li');
          li.className = 'resale-demo__myrequests-item';

          const status = item.status || 'en_attente';

          const head = document.createElement('div');
          head.className = 'resale-demo__myrequests-item-head';

          const title = document.createElement('p');
          title.className = 'resale-demo__myrequests-title';
          title.textContent = (item.brand_model || '').trim() || 'Demande sans titre';

          const badge = document.createElement('span');
          badge.className = `resale-demo__myrequests-status ${statusClass(status)}`;
          badge.textContent = labelStatus(status);

          head.appendChild(title);
          head.appendChild(badge);

          const meta = document.createElement('p');
          meta.className = 'resale-demo__myrequests-meta';

          const details = [];
          const submittedAt = formatRequestDate(item.created_at);
          if (submittedAt) details.push(`D\u00e9pos\u00e9e le ${submittedAt}`);
          if (item.tracking) details.push(`Suivi: ${item.tracking}`);
          meta.textContent = details.join(' - ') || 'Demande en cours';

          li.appendChild(head);
          li.appendChild(meta);
          myRequestsList.appendChild(li);
        });

        if (items.length > maxItems) {
          const more = document.createElement('li');
          more.className = 'resale-demo__myrequests-more';
          const extra = items.length - maxItems;
          more.textContent = `+ ${extra} autres demandes en cours`;
          myRequestsList.appendChild(more);
        }
      };


      const loadMyRequests = async (email) => {
        if (!email) return;
        try {
          const res = await fetch(
            `https://api.fs-solutions.fr/shopify/net-lunettes/resale/v1/requests?customer_email=${encodeURIComponent(
              email
            )}`
          );
          if (!res.ok) return;
          const data = await res.json();
          if (data?.status === 'ok') {
            renderMyRequests(data.items || []);
          }
        } catch (e) {
          console.warn('loadMyRequests error', e);
        }
      };

      if (customerEmail) loadMyRequests(customerEmail);

      // Submit
      resaleForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!submitBtn) return;

        labelLink?.setAttribute('hidden', 'true');

        if (!hasAddress) {
          setStatus('Ajoutez votre adresse dans votre compte avant de valider.', 'error');
          window.location.href = '/account/addresses';
          return;
        }

        const brandModel = (brandInput?.value || '').trim();
        const category = resaleForm.querySelector('[data-input="category"] .chip--active')?.dataset.value || '';
        const condition = resaleForm.querySelector('[data-input="condition"]')?.value || '';
        const correction = resaleForm.querySelector('[data-input="correction"] .chip--active')?.dataset.value || '';

        if (!brandModel) {
          setStatus('Renseignez la marque / modèle.', 'error');
          showStep(1);
          brandInput?.focus();
          return;
        }

        if (!validateTracking()) {
          setStatus('Ajoutez un numéro de suivi valide (8-20 caractères, chiffres/lettres).', 'error');
          trackingInput?.focus();
          updateSubmitState();
          return;
        }

        if (resaleForm.dataset.mrChecklistDone !== '1') {
          setStatus('Confirmez toutes les étapes Mondial Relay avant de valider.', 'error');
          updateSubmitState();
          return;
        }

        const formData = new FormData();
        formData.append('brand_model', brandModel);
        formData.append('category', category);
        formData.append('condition', condition);
        formData.append('correction', correction);
        formData.append('tracking', (trackingInput?.value || '').trim());
        formData.append('status', 'en_attente');

        const customerId = resaleForm.querySelector('[data-customer-id]')?.value || '';
        const customerName = resaleForm.querySelector('[data-customer-name]')?.value || '';
        formData.append('customer_email', customerEmail);
        formData.append('customer_id', customerId);
        formData.append('customer_name', customerName);

        if (fileInput?.files?.length) {
          Array.from(fileInput.files).forEach((file) => formData.append('photos[]', file));
        }

        submitBtn.disabled = true;
        setStatus('Envoi de la demande...', 'loading');

        try {
          const response = await fetch('https://api.fs-solutions.fr/shopify/net-lunettes/resale/v1/submit', {
            method: 'POST',
            body: formData,
          });

          const data = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(data?.message || `HTTP ${response.status}`);
          if (data?.status !== 'ok') throw new Error(data?.message || 'Erreur inconnue');

          setStatus('Demande enregistrée. Vous pouvez suivre son statut dans Mes demandes.', 'info');

          if (data.label_url) {
            labelLink?.removeAttribute('hidden');
            labelLink?.setAttribute('href', data.label_url);
            labelLink.textContent = 'Télécharger le bordereau';
          }

          window.location.assign('/pages/mes-demandes');
          return;
        } catch (error) {
          setStatus(`Erreur : ${error.message || error}`, 'error');
        } finally {
          submitBtn.disabled = false;
          updateSubmitState();
        }
      });

      // Init
      showStep(1);
      refreshFileList();
      updateSubmitState();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
